
import { Grid, Stack } from "@mui/material";
import React from "react";
import './TitleSteps.css';
import lineaAmarilla from '../../assets/img/lineaAmarilla/decorative.svg'
import { connect } from "react-redux";

const TitlesStepsOne = (props) => {

  return (

    <>
      <div className="">
        <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" className="mX-25">
          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={0}
          >
            <div className="numero">{props.preOrder.steps}</div>
            <div className="linea-amarilla">
              <img src={lineaAmarilla} alt='' />
              <div className="text-queremos">Queremos saber m&aacute;s de {props.preOrder.addPets.length > 0 ? props.preOrder.addPets[0].nombre : props.preOrder.petName}</div>
              <div className="text-asi">As&iacute; podremos personalizar mejor su seguro.</div>
            </div>
            </Stack>
        </Grid>
      </div>
    </>

  );

}
const mapStateToProps = state => ({
  preOrder: state.preOrder
});
export default connect(mapStateToProps)(TitlesStepsOne)
